import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=4a0d9025&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/movie_serial.css?vue&type=style&index=0&id=4a0d9025&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d9025",
  null
  
)

export default component.exports